export interface IReferralMember {
  id: string;
  referralTokenId: string;
  memberEmail: string;
  creditsEarned: number;
  status: ReferralMemberEnum;
  referredName: string | null;
  updatedAt: string;
  createdAt: string;
  referralToken: {
    userId: string;
    user: {
      email: string;
      firstname: string;
      lastname: string;
    };
  };
}

export enum ReferralMemberEnum {
  "Completed",
  // Invited by email, not signed up yet
  "Invited",
  // Signed up, the reward comes with their first paid charge
  "Registered",
  // Signed up through another referral link or without one - this invitation brings no reward
  "JoinedOtherWay",
}
